module.exports = __webpack_public_path__ + "static/media/kamlesh.03de07f9.png";